<div *ngIf="isLoading">
    Please waiting data is loading.....
</div>

<mat-card>
    <mat-card-header>
        <mat-card-subtitle>
            <div *ngIf="!isLoading">
                <button mat-button (click)="bookingsGrid()" class="back-icon"><mat-icon>keyboard_backspace</mat-icon>  
                    <h3 class="service-type">Back To Bookings
                      </h3>
                </button>
                <h3 class="service-type-heading">{{overViewDetails?.serviceType}}</h3>
            </div>
        </mat-card-subtitle>
    </mat-card-header>
    
    <mat-card-content>
        <div class="bookings-overview-container" *ngIf="overViewDetails">
            <div class="status-container">
                <div class="image-container">
                    <img src="/assets/images/icons-kpi-dashboard/Date.png" alt="">
                </div>
                <div class="data-container">
                    <b>Date</b>
                   <p> {{overViewDetails.executionDate}}</p>
                </div>
            </div>
            <div  class="status-container">
                <div class="image-container">
                    <img src="/assets/images/icons-kpi-dashboard/City.png" alt="">
                </div>
                <div class="data-container">
                    <b>City & postcode</b>
                    <p>{{overViewDetails.city}}</p>
                </div>
            </div>
            <div class="status-container">
                <div class="image-container">
                    <img src="/assets/images/icons-kpi-dashboard/Amount-of-invoice.png" alt="">
                </div>
                <div class="data-container">
                    <b>Amount of Invoice</b>
                    <p>{{overViewDetails.orderValue  | currency : "EUR" : "" : "1.2-2" : "de"}}</p>
                </div>
            </div>
            <div class="record-status-container">
                <h4>Status</h4>
                <p [ngClass]="getStatusClass(overViewDetails.status)">
                    {{overViewDetails.status}} <img class="img-span" width="12" [src]="getStatusIcon(overViewDetails.status)" alt="status-icon" class="status-icon" />
                </p>
            </div>
        </div>
        
        <div class="details-container" >
        
            <div class="job-description"  *ngIf="companyId !== 4">
                <h4>Job Description</h4>
                <div *ngFor="let paragraph of overViewDetails?.jobDescriptionParagraphs; let i = index">
                    <h5>{{ paragraph.header }}</h5>
                    <div *ngFor="let text of paragraph.texts">
                        <p class="job-description-text">{{ text }}</p>
                    </div>
                </div>
            </div>
            <div class="job-description"  *ngIf="companyId === 4">
                <h4>Job Description</h4>
                    <div class="job-description-text" [innerHTML]="overViewDetails?.jobDescription"></div>
            </div>
            <div>
                <h4>Review</h4>
                @if(overViewDetails?.rating === 0){
                    <p class="rating-msg"></p>
                } @else {
                    <div class="star-rating" [innerHTML]="overViewDetails?.starRating">
                    </div>             
                }
            </div>
            
            <div>
                @if(overViewDetails?.reviewDescription === ''){
                    <p> No review by customer </p>
                } @else {
                    <p>{{overViewDetails?.reviewDescription}}</p>
                }
            </div>
            
            <div>
                <h4>Photos for Execution Job</h4>
                <div class="image-gallery">
            <div *ngFor="let image of declarationImage; let i = index" class="image-item">
                <img [src]="image.path" alt="Image {{ image.id }}" width="100" (click)="openImageDialog(i)"/>
            </div>
                  </div>
            </div>
        </div>
    </mat-card-content>
  
    
</mat-card>